type SocialNetworkWrapperProps = { children: React.ReactNode };

const SocialNetworkWrapper = ({ children }: SocialNetworkWrapperProps) => {
	return <div className={`vtex-store-footer-2-x-socialNetworkWrapper`}>{children}</div>;
};

export default SocialNetworkWrapper;
